<div class="container-fluid">
  <page-header-search
  [isSearchInput]="true"
    [pageTitleValue]="pageTitle"
    [placeholderValue]="placeholder"
    (onHeaderInputKeyup)="onSearchInputKeyup($event)"
    (onHeaderSearchSubmit)="onSearchOffer($event)"
  ></page-header-search>
  <div *ngIf="filteredLatestOffersArray.length" class="card">
    <div class="card-body">
      <div class="table-title">
        <h3 class="title mb-0">All Latest Offers</h3>
        <a (click)="invertSorting()">
          <span>↑</span>
          <span class="ml--1">↓</span>
          Sort By
        </a>
      </div>
      <div class="table-responsive">
        <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th *ngFor="let th of theadArray">{{ th | uppercase }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="pointer" *ngFor="let item of filteredLatestOffersArray">
              <td>
                <span>{{ item.name }}</span>
              </td>
              <td>
                <span>{{ item.rank }}</span>
              </td>
              <td>
                <span>{{ item.routeName }}</span>
              </td>
              <td>
                <span>{{
                  item.startDate.split()
                    ? item.startDate.split("T")[0]
                    : item.startDate
                }}</span>
              </td>
              <td>
                <span>{{
                  item.endDate.split()
                    ? item.endDate.split("T")[0]
                    : item.endDate
                }}</span>
              </td>
              <td>
                <button
                  class="btn btn-icon btn-outline-success mr-2"
                  type="button"
                  placement="top"
                  tooltip="Edit"
                  [routerLink]="['edit', item.id]"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"> </i>
                  </span>
                </button>
                <button
                  class="btn btn-icon btn-outline-warning mr-2"
                  type="button"
                  placement="top"
                  tooltip="Delete"
                  (click)="onDeleteOffer(item)"
                >
                  <span class="btn-inner--icon">
                    <i class="fa fa-trash"> </i>
                  </span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="fab-btn" [routerLink]="'add'">
  <i class="ni ni-fat-add"></i>
</div>
